const internals = {};

internals.SMOOTH_TRANSITION_ROUTE_PATHS = new Set([
    '/classes',
    '/discover',
    '/messaging'
]);

internals.addWarning = (warnings, warning) => {

    const warningKey = JSON.stringify({
        code: warning.code,
        details: warning.details
    });

    const alreadyAdded = warnings.some((existingWarning) => JSON.stringify({
        code: existingWarning.code,
        details: existingWarning.details
    }) === warningKey);

    if (!alreadyAdded) {
        warnings.push(warning);
    }
};

internals.markSmoothTransitionRoutes = (routes, parentPath = '') => {

    [].concat(routes || []).forEach((route) => {

        if (!route) {
            return;
        }

        const routePath = internals.concatPaths(parentPath, route.path || '');

        if (internals.SMOOTH_TRANSITION_ROUTE_PATHS.has(routePath)) {
            route.mountWhileResolving = true;
        }

        if (route.childRoutes) {
            internals.markSmoothTransitionRoutes(route.childRoutes, routePath);
        }
    });

    return routes;
};


exports.auditRoutes = (routes, options = {}) => {

    internals.markSmoothTransitionRoutes(routes);

    const warnings = exports.getRouteAuditWarnings(routes);

    warnings.forEach((warning) => {

        if (options.warn !== false) {
            console.warn(warning.message, warning.details);
        }
    });

    return routes;
};

exports.getRouteAuditWarnings = (routes, parentPath = '') => {

    const warnings = [];

    [].concat(routes || []).forEach((route) => {

        if (!route) {
            return;
        }

        const routePath = internals.concatPaths(parentPath, route.path || '');

        if (route.requiredPermissions && !Array.isArray(route.requiredPermissions)) {
            internals.addWarning(warnings, {
                code: 'ROUTE_REQUIRED_PERMISSIONS_NOT_ARRAY',
                message: '[routes] requiredPermissions should be an array',
                details: {
                    route: routePath,
                    requiredPermissions: route.requiredPermissions
                }
            });
        }

        if (
            route.requiredPermissionMode &&
            !['all', 'any'].includes(route.requiredPermissionMode)
        ) {
            internals.addWarning(warnings, {
                code: 'ROUTE_INVALID_REQUIRED_PERMISSION_MODE',
                message: '[routes] requiredPermissionMode should be "all" or "any"',
                details: {
                    route: routePath,
                    requiredPermissionMode: route.requiredPermissionMode
                }
            });
        }

        if (
            route.dependencyTimeoutMs !== undefined &&
            (!Number.isFinite(route.dependencyTimeoutMs) || route.dependencyTimeoutMs <= 0)
        ) {
            internals.addWarning(warnings, {
                code: 'ROUTE_INVALID_DEPENDENCY_TIMEOUT',
                message: '[routes] dependencyTimeoutMs should be a positive number',
                details: {
                    route: routePath,
                    dependencyTimeoutMs: route.dependencyTimeoutMs
                }
            });
        }

        if (route.resolveDependencies) {
            Object.entries(route.resolveDependencies).forEach(([dependencyName, resolver]) => {

                const resolvers = [].concat(resolver);

                resolvers.forEach((dependencyResolver) => {

                    if (typeof dependencyResolver !== 'function') {
                        internals.addWarning(warnings, {
                            code: 'ROUTE_INVALID_DEPENDENCY_RESOLVER',
                            message: '[routes] dependency resolver should be a function',
                            details: {
                                dependencyName,
                                resolver: dependencyResolver,
                                route: routePath
                            }
                        });
                    }
                });
            });
        }

        if (route.resolveDependencies && !route.fallback && !route.childRoutes) {
            internals.addWarning(warnings, {
                code: 'ROUTE_DEPENDENCIES_WITHOUT_FALLBACK',
                message: '[routes] route resolves dependencies without an explicit fallback',
                details: {
                    route: routePath
                }
            });
        }

        if (route.childRoutes) {
            warnings.push(...exports.getRouteAuditWarnings(route.childRoutes, routePath));
        }
    });

    return warnings;
};

internals.concatPaths = (base, path) => {

    base = base || '';
    path = path || '';

    base = base.endsWith('/') ? base.slice(0, -1) : base;
    path = path.startsWith('/') ? path.slice(1) : path;

    return `${base}/${path}`;
};

if (process.env.NODE_ENV === 'test') {
    exports._internals = internals;
}
